import React from 'react';
import './Loader.scss';

export default () => <div className="lds-ring"><div></div><div></div><div></div><div></div></div>;